import { SMSConversationState, SMSNodeStatus, SMSNodeSubStatus, SMSStatus } from 'types/sms.type';
import { formatSMSStatus } from '../../../utils';
import type { TableFilterOption } from '../../CallsTable/CallsTable';

export const SMS_ANALYTICS_DIRECTION_OPTIONS = [
    { value: 'OUTBOUND', label: 'Outbound SMS' },
    { value: 'INBOUND', label: 'Inbound SMS' },
] as const;

const SMS_STATUS_GROUPS: { category: string; statuses: string[] }[] = [
    { category: 'SMS Status', statuses: Object.keys(SMSStatus) },
    { category: 'Node Status', statuses: Object.keys(SMSNodeStatus) },
    { category: 'Conversation State', statuses: Object.keys(SMSConversationState) },
    { category: 'Node Sub Status', statuses: Object.keys(SMSNodeSubStatus) },
];

/**
 * Some statuses (QUEUED, SENT, FAILED) exist in several SMS enums. They resolve to the same
 * request param, so only the first occurrence is offered to keep option values unique.
 */
export const SMS_ANALYTICS_STATUS_OPTIONS: TableFilterOption[] = SMS_STATUS_GROUPS.reduce<TableFilterOption[]>(
    (options, { category, statuses }) => {
        const usedValues = new Set(options.map((option) => option.value));
        const groupOptions = statuses
            .filter((status) => !usedValues.has(status))
            .map((status) => ({ value: status, label: formatSMSStatus(status), category }));

        return [...options, ...groupOptions];
    },
    []
);
